import { CircularProgress, ListItemButton } from "@mui/material";
import { useContext } from "react";
import useResponsive from "src/hooks/useResponsive";

import Context from "../context";
import { PeriodsType } from "../types";
import ItemLabel from "./ItemLabel";

type Props = {
	size?: "small" | "medium";
	period: PeriodsType;
};

ItemButton.defaultProps = {
	size: "medium"
};

export default function ItemButton({ period, size }: Props) {
	const isMobile = useResponsive("down", "sm");
	const isSmall = size === "small" || isMobile;
	const { state, actions } = useContext(Context);
	const { selectedPeriod, isLoading } = state;

	const isSelected = selectedPeriod === period;
	const loading = isLoading && isSelected;

	function onPress(keySelected: PeriodsType) {
		if (state.selectedPeriod !== period) actions.setPeriod(keySelected);
	}

	return (
		<ListItemButton
			key={period}
			onClick={() => onPress(period)}
			sx={{
				":hover": {
					backgroundColor: isSelected ? "primary.main" : "action.hover"
				},
				justifyContent: "center",
				flexGrow: 0,
				px: 1,
				borderRadius: isSmall ? 0.8 : 1.2,
				minWidth: isSmall ? 35 : 50,
				py: loading ? (isSmall ? 0.5 : 1) : isSmall ? 0.4 : 0.9,
				backgroundColor: isSelected ? "primary.main" : "background.paper"
			}}
		>
			{loading ? (
				<CircularProgress color='inherit' disableShrink size={isSmall ? 14 : 16} />
			) : (
				<ItemLabel isSelected={isSelected} period={period} size={size} />
			)}
		</ListItemButton>
	);
}
